import type { ApiError, NetworkError } from '@/lib/api/types';

const record = (value: unknown): Record<string, unknown> | undefined =>
  value !== null && typeof value === 'object' && !Array.isArray(value)
    ? (value as Record<string, unknown>)
    : undefined;

const nonEmptyString = (value: unknown): string | undefined =>
  typeof value === 'string' && value.trim() ? value : undefined;

export async function normalizeApiError(response: Response): Promise<ApiError> {
  const payload = record(await response.json().catch(() => undefined));
  const serverFailure = response.status >= 500;
  const message = serverFailure
    ? 'Ha ocurrido un error en el servidor.'
    : (nonEmptyString(payload?.message) ?? 'No se pudo completar la solicitud.');
  const details = !serverFailure ? record(payload?.details) : undefined;
  const error: ApiError = {
    name: 'ApiError',
    status: response.status,
    message,
    code: nonEmptyString(payload?.code),
    details,
    errorId: serverFailure ? nonEmptyString(payload?.errorId) : undefined,
    traceId: nonEmptyString(payload?.traceId),
  };

  return { ...error, body: { ...error } };
}

export function normalizeNetworkError(): NetworkError {
  return {
    name: 'NetworkError',
    status: 0,
    message: 'No se pudo conectar con el servidor.',
  };
}
